import request from "@/utils/request";
import {IStorageModel} from "./types";

export const defaultSpaceData: IStorageModel = {
    id: null,
    name: null,
    storageRowType: null,
    storageType: null,
    children: []
};


export const getStorages = () =>
    request({
        url: "/storages",
        method: "get"
    });

export const createStorage = (data: any) =>
    request({
        url: '/storages',
        method: 'post',
        data
    })


export const getAvailableStorageLayers = (params: {isReserved:boolean, deliveryNoteId: string}) =>
  request({
    url: `/storages/available`,
    method: "get",
    params
  });

export const deleteStorage = (id: string, type: string) =>
    request({
        url: `/storages/${type}/${id}`,
        method: "delete"
    });

export const storageLayerDeliveryNotes = (data: any) =>
    request({
        url: `/storage-layer-delivery-notes`,
        method: "post",
        data
    });

export const updateStorageColumnRemark = (id: string, data: any) =>
    request({
        url: `/storage-columns/${id}/remark`,
        method: "put",
        data
    });

export const getAllMultipleStorageRows = () =>
  request({
    url: `/storage-rows/multiple/storage-layers`,
    method: "GET"
  });

export const updateStorage = (data: any) =>
  request({
    url: '/storages',
    method: 'put',
    data
  });

export const updateUpload = (id: string, params:any) =>
  request({
    url: `/delivery-notes/${id}/upload`,
    method: 'put',
    params
  })